export default "__VITE_ASSET__h_uFden8__"